<template>
	<div class="text-left" @click="$emit('click',$event)">
		<div class="form-question">{{ item.question }} <span v-if="item.required" class="font-red brand-medium">*</span></div>
		<v-form @submit.prevent v-model="isValid" lazy-validation ref="form">
			<v-file-input
				class="file-upload"
				:disabled="!editMode"
				hide-details
				dense
				:multiple="item.multi"
				:placeholder="item.placeholder"
				:outlined="outlined"
				:solo="solo"
				:filled="filled"
				append-icon="attach_file"
				:accept="accept"
				v-model="files"
				:rules="item.required ? fileInputRequired : []"
				@change="handleChange"
			>
				<template v-slot:selection="{ text }">
					<v-chip small label color="primary">
						{{ text }}
					</v-chip>
				</template>
			</v-file-input>
		</v-form>
	</div>
</template>

<script>
	import RendererMixin from "@/modules/forms/v2/schema/RendererMixin";

	export default {
		name: 'FileInput',

		props: ['editMode', 'item', 'styles','index','results'],

		components: {},

		mixins: [RendererMixin],

		data: function() {
			return {
				files: this.item.multi ? [] : null,
			};
		},

		mounted() {
			let currentResult = this.getCurrentResult(this.item.id,this.results);
			if(currentResult){
				this.files = currentResult;
			}
		},

		beforeDestroy() {},

		methods: {
			handleChange: function() {
				if(this.item.multi && this.files.length){
					this.$emit('input', {item: this.item, value: this.files, index: this.index});
					return;
				}else if(!this.item.multi && this.files){
					this.$emit('input', {item: this.item, value: [this.files], index: this.index});
					return;
				}

				this.$emit('input', {item: this.item, value: null, index: this.index});
			},
		},

		computed: {
			fileInputRequired() {
				if(this.item.multi){
					return [this.files.length > 0 || 'Required'];
				}else{
					return [this.files != null || 'Required'];
				}
			},

			accept: function(){
				if(this.item.fileTypes && this.item.fileTypes.length){
					return this.item.fileTypes.join(", ");
				}else {
					return "*/*";
				}
			}
		},
	};
</script>

<style scoped lang="scss">
	.file-upload .v-input__prepend-outer {
		display: none !important;
	}
</style>
